import { useMutation } from "@tanstack/react-query";
import type { CatalogElement } from "../../../../models/CatalogElement";
import { upsertCatalogElement } from "../../../../repositories/CatalogElementRepository";

export const useUpsertCatalogElementMutation = () => {
  return useMutation({
    mutationFn: async (element: CatalogElement) => {
      const resp = await upsertCatalogElement(element);
      if (!resp.ok)
        throw new Error(resp.message ?? "Failed to save catalog element");
      return resp;
    },
  });
};
